import { withJsonFormsControlProps } from "@jsonforms/react";
import { Checkbox } from "pepsico-ds";
import { useEffect } from "react";

export const CheckboxArrayComponent = (props) => {
  const { data, handleChange, path, uischema, enabled, label, visible } = props;

  const parameters = uischema?.options?.parameters ?? [];
  const requiredParameters = uischema?.options?.requiredParameters ?? [];
  const isEmpty = !data || data.length === 0;
  const currentArray =
    isEmpty && requiredParameters.length > 0 ? requiredParameters : (data ?? []);

  useEffect(() => {
    if (!visible) return;
    const current = data ?? [];
    const filtered = current.filter((p) => parameters.includes(p));
    const missingRequired = requiredParameters.filter((p) => !filtered.includes(p));
    const next = [...filtered, ...missingRequired];
    if (next.length !== current.length || next.some((p, i) => p !== current[i])) {
      handleChange(path, next);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  const handleToggle = (param, checked) => {
    if (requiredParameters.includes(param)) return;
    const next = checked
      ? [...currentArray, param]
      : currentArray.filter((p) => p !== param);
    handleChange(path, next);
  };

  if (!visible) return null;

  const formatText = (text) => {
    if (uischema?.options?.formatText) {
      return text
        .replaceAll("_", " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
    }
    return text;
  };

  return (
    <div className="checkbox-array-control">
      {label && <p className="checkbox-array-label font-xsmall-regular">{label}</p>}
      {parameters.map((param) => (
        <Checkbox
          key={param}
          text={formatText(param)}
          checked={currentArray.includes(param)}
          disabled={requiredParameters.includes(param) || !enabled}
          onUpdate={(checked) => handleToggle(param, checked)}
        />
      ))}
    </div>
  );
};

export const CheckboxArrayControl = withJsonFormsControlProps(
  CheckboxArrayComponent
);
